export default "__VITE_ASSET__Q4UBY0z7__"